var g = Object.defineProperty, w = Object.defineProperties;
var M = Object.getOwnPropertyDescriptors;
var h = Object.getOwnPropertySymbols;
var V = Object.prototype.hasOwnProperty, I = Object.prototype.propertyIsEnumerable;
var b = (e, t, s) => t in e ? g(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s, k = (e, t) => {
  for (var s in t || (t = {}))
    V.call(t, s) && b(e, s, t[s]);
  if (h)
    for (var s of h(t))
      I.call(t, s) && b(e, s, t[s]);
  return e;
}, P = (e, t) => w(e, M(t));
var c = (e, t, s) => new Promise((n, u) => {
  var d = (r) => {
    try {
      i(s.next(r));
    } catch (a) {
      u(a);
    }
  }, m = (r) => {
    try {
      i(s.throw(r));
    } catch (a) {
      u(a);
    }
  }, i = (r) => r.done ? n(r.value) : Promise.resolve(r.value).then(d, m);
  i((s = s.apply(e, t)).next());
});
import { ao as N, z as E, au as Q, c as f, e as v, t as $, k as F, g as K, m as x, r as l } from "./define-element-XpjsV6s1.js";
import { _ as S } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { u as O, a as U } from "./query-client-DZ5Df1It.js";
import { u as p } from "./useMutation-DFzOBEuf.js";
import { u as B } from "./use-user-CwEHAZOt.js";
import { u as D } from "./use-cart-D8NOb7eE.js";
const L = {
  __name: "Checkbox",
  props: {
    modelValue: {},
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = N(e, "modelValue");
    return (s, n) => E((f(), v("input", {
      class: "offset-checkbox",
      type: "checkbox",
      "onUpdate:modelValue": n[0] || (n[0] = (u) => t.value = u)
    }, null, 512)), [
      [Q, t.value]
    ]);
  }
}, X = /* @__PURE__ */ S(L, [["__scopeId", "data-v-63561aa2"]]), T = {}, A = {
  class: "offset-loader-input",
  role: "status"
}, C = { key: 0 };
function J(e, t) {
  return f(), v("div", A, [
    e.$attrs.label ? (f(), v("label", C, $(e.$attrs.label), 1)) : F("", !0),
    t[0] || (t[0] = K("input", {
      type: "text",
      disabled: "",
      "aria-hidden": "true"
    }, null, -1))
  ]);
}
const Y = /* @__PURE__ */ S(T, [["render", J], ["__scopeId", "data-v-63806149"]]);
function Z() {
  const e = O(), { isValidUser: t } = B(), { cart: s } = D(), n = U({
    queryKey: ["payment", t],
    queryFn: () => c(null, null, function* () {
      if (!t.value)
        return [];
      let a = yield l("payment");
      return Array.isArray(a) || (a = Object.keys(a).map((o) => a[o])), a;
    })
  }), u = p({
    mutationFn: (a) => c(null, null, function* () {
      const o = yield l("payment", {
        method: "POST",
        body: JSON.stringify(a)
      });
      if (o.error)
        throw new Error(o.error);
      return o;
    }),
    onSuccess: () => {
      e == null || e.invalidateQueries({ queryKey: ["payment", t] });
    }
  }), d = p({
    mutationFn: (a) => c(null, null, function* () {
      return yield l(`payment/${a.id}`, {
        method: "PUT",
        body: JSON.stringify(a)
      });
    }),
    onSuccess: () => {
      e == null || e.invalidateQueries({ queryKey: ["payment", t] });
    }
  }), m = p({
    mutationFn: (a) => c(null, null, function* () {
      return yield l(`payment/${a}`, {
        method: "DELETE"
      });
    }),
    onSuccess: () => {
      e == null || e.invalidateQueries({ queryKey: ["payment", t] });
    }
  }), i = x(() => n.data.value && n.data.value.length > 0), r = x(() => {
    var _;
    if (!i.value)
      return null;
    const a = parseInt((_ = s.value) == null ? void 0 : _.config.payment_id, 10);
    let o = null;
    return isNaN(a) ? (o = n.data.value.find(
      (y) => y.default === "1"
    ), o || (o = n.data.value[0])) : o = n.data.value.find(
      (y) => parseInt(y.id, 10) === a
    ), o;
  });
  return P(k({}, n), {
    hasPayments: i,
    selectedPayment: r,
    createPaymentMutation: u,
    updatePaymentMutation: d,
    deletePaymentMutation: m
  });
}
export {
  X as C,
  Y as L,
  Z as u
};
